import type { ReactNode } from 'react'
import styles from './EditorPage.module.css'

export interface EditorPageProps {
  children?: ReactNode
  testId?: string
}

/**
 * A scrolling page of the legend editor, like an options tab, with its
 * content in a centered column.
 */
export function EditorPage({ children, testId }: EditorPageProps) {
  return (
    <div className={styles.root} data-test={testId}>
      <div className={styles.column}>{children}</div>
    </div>
  )
}
